import { api } from "./api";

// Records a finished drill for clan rankings. Guests get a 401 which we silently ignore.
export function recordSession({ kind, category, mode = "any", score }) {
  return api.post("/sessions", { kind, category, mode, score: Math.max(0, Math.round(score)) }).catch(() => null);
}
